import axios from "axios";
import { DEFAULT_API_ERROR_CODE } from "./errors";
import { ApiError, ProcessedApiResponse, UrlParams } from "./interfaces";

const baseApiUrl = process.env.REACT_APP_BASE_API_URL;

const getGenericApiErrorResponse = <
  Data = undefined
>(): ProcessedApiResponse<Data> => ({
  success: false,
  error: {
    code: DEFAULT_API_ERROR_CODE,
    msg: "",
  },
});

export const buildQueryString = (params: UrlParams): string => {
  return new URLSearchParams(params).toString();
};

export const get = async <Data>(
  endpoint: string,
  params: UrlParams = {}
): Promise<ProcessedApiResponse<Data>> => {
  try {
    const response = await axios.get(`${baseApiUrl}${endpoint}`, {
      params,
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch {
    return getGenericApiErrorResponse();
  }
};

export const post = async <Data = undefined>(
  endpoint: string,
  params: UrlParams = {}
): Promise<ProcessedApiResponse<Data>> => {
  try {
    const response = await axios.post(`${baseApiUrl}${endpoint}`, params, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch {
    return getGenericApiErrorResponse();
  }
};

export const hasErrorCode = (
  errorCode: string,
  responseError?: ApiError
): boolean => {
  if (!responseError?.errors) {
    return false;
  }

  if (responseError.code === errorCode) {
    return true;
  }

  const { errors } = responseError;

  for (let index = 0; index < errors.length; index += 1) {
    const error = errors[index];

    if (error.code === errorCode) {
      return true;
    }
  }

  return false;
};
